import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import { useTranslation } from 'next-i18next';

const styles = theme => ({
  root: {
    padding: '26px 20px',
    backgroundColor: '#31415E',
    color: '#fff',
    [theme.breakpoints.up('sm')]: {
      padding: '28px 20px',
      minHeight: 145,
    },
  },
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    padding: 0,
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
    },
  },
  copy: {
    color: '#fff',
  },
  sellerLink: {
    color: '#fff',
  },
  leftContentContainer: {
    display: 'flex',
  },
  facebookIconWrapper: {
    paddingRight: 12,
    position: 'relative',
    top: -4,
  },
  logoWrapper: {
    paddingTop: 70,
    [theme.breakpoints.up('sm')]: {
      paddingTop: 0,
    },
  },
});

const GlobalFooterWithSellerInfo = ({ classes, facebookPageId = '', facebookPageName = '' }) => {
  const { t } = useTranslation('common');
  return (
    <div className={classes.root}>
      <div className={['container', classes.container].join(' ')}>
        <div>
          <div className={classes.leftContentContainer}>
            <div className={classes.facebookIconWrapper}>
              <img src="/static/images/facebookIconBright.svg" width="26" />
            </div>
            {facebookPageName && facebookPageId ? (
              <div>
                {facebookPageName}
                <br />
                <div>
                  <a
                    href={`https://www.facebook.com/${facebookPageId}`}
                    className={classes.sellerLink}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <u>{t('contact-us')}</u>
                  </a>{' '}
                  {t('if-have-question')}
                </div>
              </div>
            ) : (
              ''
            )}
          </div>
        </div>
        <div className={classes.logoWrapper}>
          <Typography align="center" className={classes.copy}>
            Powered by{' '}
            <a
              href="https://www.sellonlive.tech/"
              target="_blank"
              title="SellOnLive"
              rel="noreferrer"
            >
              <img src="/static/images/logoWhite.svg" width="84" />
            </a>
          </Typography>
        </div>
      </div>
    </div>
  );
};

GlobalFooterWithSellerInfo.propTypes = {
  classes: PropTypes.object.isRequired,
  facebookPageId: PropTypes.string.isRequired,
  facebookPageName: PropTypes.string.isRequired,
};

export default withStyles(styles)(GlobalFooterWithSellerInfo);
